import React, { useState, useEffect } from "react";
import "./style.css";

const TableControls = ({
  onSearch,
  onEntriesChange,
  entriesOptions = [10, 25, 50, 100],
  placeholder = "Buscar...",
  searchLabel = "Buscar",
  entriesLabel = "Mostrar",
  resultsLabel = "resultados",
  debounceTime = 400,
  liveSearch = true,
}) => {
  const [searchValue, setSearchValue] = useState("");

  // 🔎 Efecto con debounce para búsqueda en vivo
  useEffect(() => {
    if (!liveSearch) return; // si es búsqueda manual, no hace nada aquí
    const handler = setTimeout(() => {
      onSearch(searchValue);
    }, debounceTime);

    return () => clearTimeout(handler);
  }, [searchValue, debounceTime, onSearch, liveSearch]);

  return (
    <div className="row justify-content-between mb-2">
      {/* Selector de cantidad */}
      <div className="col-sm-12 col-md-4">
        <div className="dataTables_length" id="dataTables_length">
          <label className="d-flex justify-content-end align-items-center">
            <span className="mr-2 p-2">{entriesLabel}</span>
            <select
              name="datatables_length"
              aria-controls="datatables_length"
              className="custom-select custom-select-sm form-control-sm narrow-select p-2"
              onChange={onEntriesChange}
            >
              {entriesOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <span className="ml-2 p-2">{resultsLabel}</span>
          </label>
        </div>
      </div>

      {/* Filtro de búsqueda */}
      <div className="col-sm-12 col-md-6">
        <div className="datatables_filter" id="datatables_filter">
          <label
            className="d-flex justify-content-end align-items-center"
            style={{ gap: "1rem" }}
          >
            <span className="mr-2 p-2">{searchLabel}</span>
            <input
              type="search"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value.trimStart())}
              className="form-control form-control-sm"
              placeholder={placeholder}
              aria-controls="datatables"
            />
            {!liveSearch && (
              <button
                className="btnn ml-2"
                onClick={() => onSearch(searchValue)}
              >
                Buscar
              </button>
            )}
          </label>
        </div>
      </div>
    </div>
  );
};

export default TableControls;
